import { format } from 'date-fns';
import config from '../config/index.js';

/* eslint-disable no-console */
const log = (...rest) => {
  if (config.DEBUG === '1') console.log(format(Date.now(), 'HH:mm:ss:SSS'), ...rest);
};

const g = name => {
  const method = console.group ? console.group : console.log;
  if (config.DEBUG === '1') method(name);
};

const gc = name => {
  const method = console.groupCollapsed ? console.groupCollapsed : console.log;
  if (config.DEBUG === '1') method(name);
};

const ge = name => {
  const method = console.groupEnd ? console.groupEnd : console.log;
  if (config.DEBUG === '1') method(name);
};

const info = (...rest) => {
  const method = console.info ? console.info : console.log;
  if (config.DEBUG === '1') method(...rest);
};

const warn = (...rest) => {
  if (config.DEBUG === '1') console.warn.apply(null, rest);
};

const error = (...rest) => {
  if (config.DEBUG === '1') console.error.apply(null, rest);
};

const count = (...rest) => {
  if (config.DEBUG === '1') console.count.apply(null, rest);
};

const exp = obj => {
  if (config.DEBUG === '1') Object.keys(obj).forEach(key => console.log(`${key}:`, obj[key]));
};

export default {
  log,
  info,
  warn,
  error,
  count,
  g,
  gc,
  ge,
  exp,
};
